(function () {
    'use strict';

    angular.module('filter')
        .service('filterConfigService', filterConfigService);

    filterConfigService.$inject = ['serviceBase'];
    function filterConfigService(serviceBase) {
        return {
            roadAutocompleteURL: serviceBase + '/road/search?p=',
            userAutocompleteURL: serviceBase + '/user/search?p='
        };
    }
})();
